import { useEffect, useId, useRef } from 'react'
import { Icon } from '../icons/Icon.jsx'
import styles from './ui.module.css'

/**
 * Accessible modal dialog on the native <dialog> element (focus trap, Esc,
 * inert background for free).
 */
export function Dialog({ open, onClose, title, description, children, footer, width = 480 }) {
  const ref = useRef(null)
  const titleId = useId()
  const descId = useId()

  useEffect(() => {
    const dialog = ref.current
    if (!dialog) return
    if (open && !dialog.open) dialog.showModal()
    if (!open && dialog.open) dialog.close()
  }, [open])

  return (
    <dialog
      ref={ref}
      className={styles.dialog}
      style={{ width }}
      aria-labelledby={titleId}
      aria-describedby={description ? descId : undefined}
      onClose={onClose}
      onCancel={(event) => {
        event.preventDefault()
        onClose()
      }}
      onClick={(event) => {
        if (event.target === ref.current) onClose()
      }}
    >
      {open ? (
        <div className={styles.dialogBody}>
          <div className={styles.dialogHead}>
            <h2 id={titleId}>{title}</h2>
            <button type="button" className="icon-btn" aria-label="Close" onClick={onClose}>
              <Icon name="close" size={14} strokeWidth={1.7} />
            </button>
          </div>
          {description ? (
            <p id={descId} className={styles.dialogDescription}>
              {description}
            </p>
          ) : null}
          {children}
          {footer ? <div className={styles.dialogFooter}>{footer}</div> : null}
        </div>
      ) : null}
    </dialog>
  )
}
